import {
  IconAnalytics,
  IconBell,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconShareGray,
  IconWarning,
} from '@assets/images/icon';
import { rtlsSystem3 } from '@assets/images/solution';
import video from '@src/assets/images/solution/retailExhibition/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/retailExhibition/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/retailExhibition/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/retailExhibition/video/sub/rtlsVideo3.mp4';

import image1 from '@src/assets/images/solution/retailExhibition/img/1.avif';
import image2 from '@src/assets/images/solution/retailExhibition/img/2.avif';
import image3 from '@src/assets/images/solution/retailExhibition/img/3.avif';
import image4 from '@src/assets/images/solution/retailExhibition/img/4.avif';
import image5 from '@src/assets/images/solution/retailExhibition/img/5.avif';

export default {
  type: 'リテールソリューション',

  banner: {
    title: '来場者の位置を追跡し、作品案内を自動化',
    desc: '来場者が着用するUWBタグで位置をリアルタイム追跡し、作品に近づくと自動でカスタマイズされた案内を提供し、観覧体験を向上させます。',
  },

  video: {
    title: '作品の前に立つと、自動で案内が始まります',
    desc: '来場者が作品に近づくと自動で説明が再生されます。案内スタッフがいなくても来場者はその場で作品を理解でき、より没入感のある美術館体験を楽しめます。',
    play: video,
  },

  func: [
    {
      theme: '来場者の位置に応じて作品案内を自動提供',
      title: '来場者の位置をリアルタイム確認',
      desc: '首掛け型UWBタグで来場者の位置を±20cmの精度で追跡します。来場者が作品に近づくとすぐに案内を開始します。',
      sub1: 'リアルタイム状況把握',
      icon1: IconClockGray,
      sub2: '迅速なデータ連携',
      icon2: IconShareGray,
      video: subVideo1,
    },
    {
      title: '作品接近時に自動案内',
      desc: '来場者が特定の作品に近づくと自動で作品説明が始まります。追加操作なしで詳細情報を入手できます。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: '高精度提供',
      icon2: IconRulerGray,
      image: image1,
    },
    {
      title: '入館証を活用した移動経路分析',
      desc: '来場者が着用する入館証から移動経路と滞在データを分析し、実際の関心度を把握できます。これにより展示企画と効果を最大化します。',
      sub1: '高精度提供',
      icon1: IconRulerGray,
      sub2: '迅速なデータ連携',
      icon2: IconChainLinkGray,
      image: image2,
    },
    {
      title: '危険エリア接近時の即時通知',
      desc: '来場者がフェンスを越えたり立入禁止エリアに入った場合、管理者に即時通知します。リアルタイムモニタリングで事故を未然に防ぎます。',
      sub1: '高精度提供',
      icon1: IconRulerGray,
      sub2: '迅速なデータ連携',
      icon2: IconChainLinkGray,
      video: subVideo3,
    },
    {
      theme: '観覧データを活用して展示運営を効率管理',
      title: '展示作品ごとの関心度自動分析',
      desc: '来場者が最も滞在した場所をヒートマップで可視化し、空間利用率を直感的に分析できます。人気エリアと作品を明確に把握できます。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウド保存',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: 'データ活用によるコンテンツ企画支援',
      desc: '来場者の移動経路と滞在データを分析し、次回展示企画に活用します。実際の関心度を反映し展示効果を最大化します。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウド保存',
      icon2: IconCloudCheckGray,
      video: subVideo2,
    },
    {
      title: 'ストア内商品の人気度自動分析',
      desc: '館内のショップで来場者の滞在時間と動線を分析し、商品ごとの人気度を客観的に把握します。商品構成を最適化し売上向上を図ります。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウド保存',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: '空間配置の最適化支援',
      desc: '来場者の密集データを基にリアルタイムでスタッフ配置を調整し、人員効率を最大化し運営コストを削減します。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウド保存',
      icon2: IconCloudCheckGray,
      image: image5,
    },
  ],

  subfunc: {
    title: '主な機能概要',
    desc: '',

    data: [
      {
        icon: IconLocation,
        title: '来場者位置追跡',
        desc: '来場者が着用する入館証タグをリアルタイム追跡します。',
      },
      {
        icon: IconBell,
        title: '自動作品案内',
        desc: '来場者が作品に近づくと自動で説明放送を提供します。',
      },
      {
        icon: IconRoute,
        title: '移動経路記録',
        desc: '来場者の移動経路と作品ごとの滞在時間を自動記録して分析します。',
      },
      {
        icon: IconWarning,
        title: '危険エリア接近通知',
        desc: '立入禁止エリア侵入時に管理者へ即時通知します。',
      },
      {
        icon: IconAnalytics,
        title: '作品関心度分析',
        desc: '滞在位置と時間をヒートマップで可視化し、作品の関心度を分析します。',
      },
      {
        icon: IconPenSquare,
        title: '展示コンテンツ企画支援',
        desc: '観覧データを分析し、来場者の好みを展示企画に活かします。',
      },
      {
        icon: IconSearch,
        title: 'ストア商品人気度分析',
        desc: 'ストア内の来場者滞在データを分析し、商品ごとの人気を把握します。',
      },
      {
        icon: IconDashboard,
        title: 'リアルタイムスタッフ配置最適化',
        desc: '来場者密集データをリアルタイムで分析し、効率的なスタッフ配置を支援します。',
      },
      {
        icon: IconLayers,
        title: '来場者再訪率測定',
        desc: '再訪頻度と行動パターンを分析し、来場者のロイヤルティを評価します。',
      },
      {
        icon: IconChartBar,
        title: 'イベント成果測定',
        desc: 'イベント前後の来場者変化データを自動収集し、成果を評価します。',
      },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem3,
  },

  productTitle: '製品構成',
  product: [
    {
      tag: 'peoplePackage',
    },
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'manufacturingSteel',
    },
    {
      data: 'logisticsSafety',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
